// extracted by mini-css-extract-plugin
module.exports = {"Contact":"Contact-module--Contact--2lXg6","EmailLarge":"Contact-module--EmailLarge--2Hf3L","EmailSmall":"Contact-module--EmailSmall--3yQpB"};